import { useArticulosTablePage } from 'context/ArticulosTablePageContext'

const FilterActividades = () => {
  const { filterByActiveActividades, setFilterByActiveActividades } =
    useArticulosTablePage()

  const handleChange = e => {
    setFilterByActiveActividades(e.target.value)
  }

  return (
    <select
      className="filtro-articulos-select"
      id="filterActive"
      value={filterByActiveActividades}
      onChange={handleChange}
    >
      <option value="all">Todos</option>
      <option value="enabled">Habilitados</option>
      <option value="disabled">Deshabilitados</option>
    </select>
  )
}

export default FilterActividades
